<template>
	<BaseLinkButton v-if="isOsanoAvailable" :classes="classes" click-text="Cookie preferences" @click="handleClick">
		<slot>Cookie preferences</slot>
	</BaseLinkButton>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useConsentStore } from '@stores/consent';

interface Props {
	classes?: string;
}

withDefaults(defineProps<Props>(), {
	classes: 'text-color-current-color text-decoration-underline text-link--dark-mode'
});

const consentStore = useConsentStore();

const isOsanoAvailable = computed((): boolean => consentStore.isOsanoAvailable);

function handleClick(): void {
	consentStore.openPreferencesDrawer();
}
</script>
